import axios from 'axios'

export function getBalancesForEwarrant(
  contractId: number[],
  limit: number = 25,
  offset: number = 0,
  accountId?: string[],
) {
  let path = `/md3api/balances/ewarrants?contractId=${contractId}&limit=${limit}&offset=${offset}`

  if (accountId) {
    path = path + `&accountId=${accountId}`
  }

  return axios.get(path)
}

function getEwarrants(
  status: number[],
  contractId: number[],
  limit: number = 25,
  offset: number = 0,
  accountId?: string[],
) {
  let path = `/md3api/ewarrants?contractId=${contractId}&limit=${limit}&offset=${offset}&status=${status}`

  if (accountId) {
    path = path + `&accountId=${accountId}`
  }

  return axios.get(path)
}

export function getBaseContracts(marketplaceId?) {
  const activeMarketplace = marketplaceId || window['md3'].marketplace.filter({
    where: {
      'metaldesk.active': true
    }
  })[0].id

  return window['md3'].contract.filter({
    where: {
      marketplaceId: activeMarketplace,
      contractStatusId: {
        in: [ContractStatus.active]
      },
      allowEwarrant: true
    }
  })
}

export const getCreatedEwarrants = getEwarrants.bind(null, [EwarrantStatus.created, EwarrantStatus.segregated])
export const getCertifiedEwarrants = getEwarrants.bind(null, [EwarrantStatus.certified])
export const getCancelledEwarrants = getEwarrants.bind(null, [EwarrantStatus.cancelled])

export function requestEwarrant (accountId: string, contractIdRef: number, quantity: number) {
  const contractId = contractIdRef.toString()
  const body = {
    data: {
      type: 'ewarrant',
      attributes: { accountId, contractId, quantity }
    }
  }

  const path = `/md3api/ewarrant`

  return axios.post(path, body)
}

export function certifyEwarrant (ewarrantId: number) {
  const path = `/md3api/ewarrant/certify/${ewarrantId}`
  return axios.post(path)
}

export function cancelEwarrant (ewarrantId: number) {
  const path = `/md3api/ewarrant/${ewarrantId}`
  return axios.delete(path)
}

export function segregateVaultItemAgainstEwarrant (ewarrantId: number, vaultItemId: string) {
  const path = `/md3api/ewarrant/segregate_specific_vault_item_to_ewarrant`

  const body = {
    data: {
      type: 'ewarrant',
      attributes: {
        ewarrantId: ewarrantId.toString(),
        vaultItemId: vaultItemId
      }
    }
  }

  return axios.post(path, body)
}

export function getAvailableVaultItems(contractId: number) {
  return axios.get(`/md3api/available_vault_items/${contractId}`)
}

export function getContractIdsWithEwarrantHistory(marketplaceId: number) {
  return axios.get(`/md3api/ewarrants/contractsWithHistory?marketplaceId=${marketplaceId}`)
}



// WEBPACK FOOTER //
// ./react/api/ewarrants.ts